module.exports = __webpack_public_path__ + "media/images/lb/124-2cbeb6a0afae6ff32d503dad7f5ec975.svg";